import { createContext, useContext, useLayoutEffect, useState } from 'react';

const PrivacyContext = createContext();

export function PrivacyProvider({ children }) {
  const [hidden, setHidden] = useState(() => localStorage.getItem('privacyMode') === 'true');

  useLayoutEffect(() => {
    document.documentElement.setAttribute('data-privacy', hidden ? 'hidden' : 'visible');
    localStorage.setItem('privacyMode', String(hidden));
  }, [hidden]);

  return (
    <PrivacyContext.Provider value={{ hidden, toggle: () => setHidden(h => !h) }}>
      {children}
    </PrivacyContext.Provider>
  );
}

export const usePrivacy = () => useContext(PrivacyContext);
